const STRINGS = {
 hello_nice_to_meet: "Hello, nice to meet you!",
 touch_to_start: "Please press the button above to start our journey",
};

export default STRINGS;
